class PDFTemplatesService {    
    static getPDFTemplates(allPdfs: boolean, mappingId: number, includeEmpty: boolean = false): Array<PdfTemplate> {
        let pdfTemplates: Array<PdfTemplate> = [];
        if (includeEmpty) {
            pdfTemplates.push(new PdfTemplate({ id: 0, name: ' '}));
        }

        let o = {
            url: urlConfigs.pdfTemplate + "GetPdfTemplates",
            data: {
                allPdfs: allPdfs,
                mappingId: mappingId
            },
            dataType: "json",
            async: false
        } as RequestServerParams;
        o.successFunction = function (result, e) {
            pdfTemplates = [...pdfTemplates, ...createInstances(PdfTemplate, result.templates ?? [])]
        };
        o.failureFunction = function (textStatus, errorThrown, errorItem: IError) {
            errorItem.userMessage = `Failed to get PDF templates`;
            irGlobal.defaultErrorFunction(errorItem.userMessage, textStatus, errorThrown);
        };

        irGlobal.requestServer(o);

        return pdfTemplates;
    }

    private static _variables: Array<PDFTemplateVariable> = null;
    static get variables() {
        if (!this._variables) {
            let self = this;
            let o = {
                url: urlConfigs.pdfTemplate + "GetVariables",
                data: { },
                dataType: "json",
                async: false
            } as RequestServerParams;
            o.successFunction = function (result, e) {
                self._variables = createInstances(PDFTemplateVariable, result.variables);
            };
            o.failureFunction = function (textStatus, errorThrown, errorItem: IError) {
                errorItem.userMessage = `Failed to get PDF variables`;
                irGlobal.defaultErrorFunction(errorItem.userMessage, textStatus, errorThrown);
            };

            irGlobal.requestServer(o);
        }

        return this._variables;
    }
}

class PDFTemplateVariable {
    name: string;
    value: string;

    constructor(data) {
        this.name = data.name;
        this.value = data.value;
    }
}